<template>
  <md-card class="md-card-tabs"
    :class="[
      {'flex-column': flexColumn},
      {'nav-pills-icons': navPillsIcons},
      {'md-card-plain': plain}
    ]">
    <md-card-header>
      <slot name="header-title"></slot>
    </md-card-header>
    <drop-down direction="down" class="crops-tabs-mobile">
      <md-button slot="title" class="md-button md-success md-sm dropdown-toggle" data-toggle="dropdown">
        {{activePanel}}
      </md-button>
      <ul class="dropdown-menu dropdown-menu-left">
        <li v-for="(item, index) in tabName"
            @click="switchPanel(tabName[index])"
            :key="item">{{tabName[index]}}</a></li>
      </ul>
    </drop-down>
    <md-card-content>
      <md-list class="crops-tabs nav-tabs">
        <md-list-item
          v-for="(item, index) in tabName"
          @click="switchPanel(tabName[index])"
          :key="item"
          :class="[
            {active: isActivePanel(tabName[index])},
            {[getColorButton(colorButton)]: isActivePanel(tabName[index])}]">
            {{tabName[index]}}
            <md-icon v-if="navPillsIcons">{{tabIcon[index]}}</md-icon>
        </md-list-item>
      </md-list>

      <transition name="fade" mode="out-in">
        <div class="crops-tabs tab-content">
          <div
            :class="getTabContent(index + 1)"
            v-for="(item, index) in tabName"
            :key="item"
            v-if="isActivePanel(tabName[index])">
            <slot :name="getTabContent(index + 1)">
              This is the default text!
            </slot>
          </div>
        </div>
      </transition>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  props: {
    flexColumn: Boolean,
    navPillsIcons: Boolean,
    plain: Boolean,
    tabName: Array,
    tabIcon: Array,
    colorButton: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      activePanel: this.tabName[0]
    }
  },
  methods: {
    switchPanel(panel) {
      this.activePanel = panel
    },
		isActivePanel(panel) {
      return this.activePanel == panel;
		},
    getColorButton: function(colorButton) {
      return 'md-'+ colorButton + ''
    },
    getTabContent: function(index) {
      return 'tab-pane-'+ index +''
    }
  }
}
</script>

<style lang="css">
.flex-column .tab-content{
  width: 100%
}
.dropdown-menu {
  min-width: fit-content !important;
  left: 0 !important;
}
.crops-tabs-mobile{
  display: none;
}
.crops-tabs-mobile .md-button{
  width: 98%;
  margin-left: 5px;
  margin-right: 5px;
}
.crops-tabs-mobile .dropdown-menu li {
  padding: 5px 1.5rem;
  font-size: 12px;
}
@media only screen and (max-width: 600px) {
  .crops-tabs.nav-tabs {
    display: none;
  }
  .crops-tabs.tab-content{
    width: 100%;
    padding-left: 0;
  }
  .crops-tabs-mobile{
    display: block;
  }
  .az-tabs .md-card-content{
    padding: 10px 0 !important;
  }
}
</style>
